
import React, { createContext, ReactElement, useState, Dispatch, SetStateAction, useEffect, useMemo } from "react";
import { IndicacaoSituacaoTipoType } from "./types";

interface IndicacaoContextProps {
  listaIndicacaoSituacaoTipo: IndicacaoSituacaoTipoType[];
  setListaIndicacaoSituacaoTipo: Dispatch<SetStateAction<IndicacaoSituacaoTipoType[]>>;
}

export const IndicacaoContext = createContext({} as IndicacaoContextProps);

export function IndicacaoProvider({ children }: { children: ReactElement }) {
  const [listaIndicacaoSituacaoTipo, setListaIndicacaoSituacaoTipo] = useState([] as IndicacaoSituacaoTipoType[]) 

  const valuesProvider = useMemo(()=>({
    listaIndicacaoSituacaoTipo,
    setListaIndicacaoSituacaoTipo
  }),[listaIndicacaoSituacaoTipo])

  return (
      <IndicacaoContext.Provider
          value={valuesProvider}
      >
          {children}
      </IndicacaoContext.Provider>
  );
}
